import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'rose_plastic',
} as IModuleProps;
